/** @jsx h */
import { h } from 'preact'
import Avatar from './Avatar'

/**
 * UserProfile
 *
 * A component that displays an avatar and 2 lines of text.
 *
 * Not to be confused with ModalCard/Profile.jsx
 *
 * This is meant to be used within a <blockquote>, hence the <cite> tag
 * for the product name. For the rationale behind this decision, see:
 * https://css-tricks.com/quoting-in-html-quotations-citations-and-blockquotes/#aa-hey-what-about-the-figure-element
 *
 */
const UserProfile = ({ name, avatarUrl, citation, reversedColumns }) =>
  <figure class='UserProfile'>
    <Avatar url={avatarUrl} altText='' size='xsmall' />
    <figcaption class={reversedColumns ? 'flex flex-col-reverse' : ''}>
      <div class='HintUI--emphasis'>{name}</div>
      {citation &&
        <cite class='HintUI' style={{ fontStyle: 'normal'/* resets the italic added by browsers */ }}>{citation}</cite>}
    </figcaption>
  </figure>

export default UserProfile
